__webpack_public_path__ = process.env.ASSET_PATH;

import './bootstrap';
import './classes';
import './directives';
import './hoopdecor';
import router from './routes-external-catalog';

window.EventBus = new Vue();
window.loading =(loading=true)=>{
    EventBus.$emit('isLoadingGeneral', loading);
};

import VueLocalStorage from 'vue-localstorage'

Vue.use(VueLocalStorage);

import {mask} from 'vue-the-mask'
export default {
  directives: {mask}
}

Vue.component('project-related', ()=>import(/* webpackPreload: true */'./ExternalCatalog/project-related.vue'));
Vue.component('related-projects', ()=>import(/* webpackPreload: true */'./ExternalCatalog/Components/related-projects.vue'));
Vue.component('optin-change', ()=>import(/* webpackPreload: true */'./Dashboard/17_Leads/campaign/Integrations/Components/optin-change'));

import {mix_general} from "./mixins";

window.vueappCatalog = new Vue({

    mixins:[mix_general],
    el: '#app-catalog',

    router,

    data: {
        isLoadingGeneral: false,
    },

    created() {
        EventBus.$on('isLoadingGeneral', (isLoadingGeneral) => {
            this.isLoadingGeneral = isLoadingGeneral;
        });
    },

    mounted() {
    },

    methods: {
    },
});
